import { AHText, AHTextFonts, Box } from "arkh";
import { View } from "react-native";
import React from "react";
import { DateTime } from "luxon";
import { RoutineOccasionFollowupResultCell } from "./RoutineOccasionFollowupResultCell";
import { formatDate } from "./formatDate";
import { graphql, useFragment } from "react-relay";
import { RoutineOccasionFollowupColumn_RoutineOccasion$key } from "./__generated__/RoutineOccasionFollowupColumn_RoutineOccasion.graphql";
import { RoutineOccasionFollowupColumn_routine$key } from "./__generated__/RoutineOccasionFollowupColumn_routine.graphql";
import {
  sectionHeight,
  taskHeaderHeight,
  taskResultHeight,
  taskSpaceHeight,
} from "./taskHeaderHeight";

export function RoutineOccasionFollowupColumn(props: {
  routine: RoutineOccasionFollowupColumn_routine$key;
  occasion: RoutineOccasionFollowupColumn_RoutineOccasion$key;
  itemWidth: number;
  dateFormating: "WEEKDAYS" | "HOURS" | "DATES";
}) {
  const routine = useFragment(
    graphql`
      fragment RoutineOccasionFollowupColumn_routine on Routine {
        activeSections(endAt: $endAt, startAt: $startAt) {
          id
          assignedTeam {
            id
            name
          }
          lastVersion {
            id
            title
            tasks {
              __typename
              id
              title
            }
          }
        }
      }
    `,
    props.routine
  );

  const occasion = useFragment(
    graphql`
      fragment RoutineOccasionFollowupColumn_RoutineOccasion on RoutineOccasion {
        id
        startAt
        endAt
        status
        occasionSections {
          id
          section {
            id
          }
          taskExecutions {
            id
            task {
              id
            }
            ...RoutineOccasionFollowupResultCell_taskExecution
          }
        }
      }
    `,
    props.occasion
  );

  const date = DateTime.fromISO(occasion.startAt);
  const { title, subtitle } = formatDate(props.dateFormating, date);

  return (
    <View
      style={{
        width: props.itemWidth,
        overflow: "hidden",
        alignItems: "center",
        flex: 1,
      }}
    >
      <View
        style={{
          flex: 1,
          aspectRatio: 1,
          alignItems: "center",
          height: 50,
          overflow: "hidden",
        }}
      >
        <View style={{ margin: 7 }}>
          <AHText
            style={{ textAlign: "center" }}
            font={AHTextFonts.REGULAR}
            size={12}
          >
            {title}
          </AHText>
          <AHText
            style={{ textAlign: "center" }}
            font={AHTextFonts.REGULAR}
            size={10}
          >
            {subtitle}
          </AHText>
        </View>
      </View>
      {routine.activeSections.map((s) => {
        const section = occasion.occasionSections.find(
          (os) => os.section.id === s.id
        );
        return (
          <View key={s.id}>
            <View
              style={{
                height: sectionHeight,
                overflow: "hidden",
              }}
            />
            {s.lastVersion.tasks.map((task) => {
              const te = section?.taskExecutions.find(
                (te) => te.task.id === task.id
              );
              return (
                <React.Fragment key={task.id + s.id}>
                  <View
                    style={{
                      marginTop: taskHeaderHeight,
                      height: taskResultHeight,
                      overflow: "hidden",
                      justifyContent: "center",
                    }}
                  >
                    {te ? (
                      <RoutineOccasionFollowupResultCell taskExecution={te} />
                    ) : null}
                  </View>
                  <Box style={{ height: taskSpaceHeight }} />
                </React.Fragment>
              );
            })}
          </View>
        );
      })}
    </View>
  );
}
